export default "__VITE_ASSET__Ovbt49pv__"